import { render, staticRenderFns } from "./InvitationExpiries.vue?vue&type=template&id=e5dc011c&"
import script from "./InvitationExpiries.vue?vue&type=script&lang=js&"
export * from "./InvitationExpiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports